export const TAU = Math.PI * 2;

export function secureIndex(length, values = globalThis.crypto?.getRandomValues?.bind(globalThis.crypto)) {
  if (!Number.isInteger(length) || length < 1) throw new RangeError('A wheel needs at least one item.');
  if (!values) throw new Error('Secure browser randomness is unavailable.');
  const limit = Math.floor(0x1_0000_0000 / length) * length;
  const sample = new Uint32Array(1);
  do { values(sample); } while (sample[0] >= limit);
  return sample[0] % length;
}

export function chooseWinner(labels, randomIndex = secureIndex) {
  return labels[randomIndex(labels.length)];
}

export function chooseTwoLegends(labels, randomIndex = secureIndex) {
  if (!Array.isArray(labels) || labels.length === 0) throw new RangeError('A wheel needs at least one item.');
  const firstIndex = randomIndex(labels.length);
  if (labels.length === 1) return [labels[firstIndex], null];
  let secondIndex = randomIndex(labels.length - 1);
  if (secondIndex >= firstIndex) secondIndex += 1;
  return [labels[firstIndex], labels[secondIndex]];
}

// Canvas has 0 radians at 3 o'clock. The fixed pointer is on the right.
export function targetAngleForIndex(length, index, { startAngle = 0, turns = 6 } = {}) {
  if (!Number.isInteger(length) || length < 1 || !Number.isInteger(index) || index < 0 || index >= length) throw new RangeError('Invalid wheel index.');
  const slice = TAU / length;
  const alignment = -(index + 0.5) * slice;
  const target = alignment + (turns * TAU);
  return target < startAngle ? target + (Math.ceil((startAngle - target) / TAU) * TAU) : target;
}

export function easeOutQuint(progress) {
  const t = Math.min(1, Math.max(0, progress));
  return 1 - ((1 - t) ** 5);
}

export function angleAt(start, target, elapsedMs, durationMs) {
  return start + ((target - start) * easeOutQuint(elapsedMs / durationMs));
}
